// 画像や動画を保存できないようにする

function noKeep() {
  document.querySelectorAll('img, video').forEach((element) => {
    element.addEventListener('contextmenu', (event) => {
      event.preventDefault();
    });

    element.addEventListener('dragstart', (event) => {
      event.preventDefault();
    });
  });
}

export default noKeep;
